var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-chip",
    _vm._b({ attrs: { label: "" } }, "v-chip", _vm.$attrs, false),
    [
      _vm.title
        ? _c("span", { staticClass: "font-weight-bold pr-1 text-capitalize" }, [
            _vm._v(_vm._s(_vm.title) + ": "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.icon
        ? _c(
            "v-icon",
            {
              staticClass: "mr-1",
              attrs: { small: !_vm.largeIcon, color: _vm.iconColor },
            },
            [_vm._v(_vm._s(_vm.icon))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { domProps: { innerHTML: _vm._s(_vm.text) } }),
      _vm._v(" "),
      _vm.$slots.actions
        ? _c(
            "v-menu",
            {
              attrs: {
                "offset-y": "",
                "max-width": "400px",
                "max-height": "300px",
                "close-on-content-click": _vm.closeOnContentClick,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g({ attrs: { small: "", icon: "" } }, on),
                          [
                            _c("v-icon", [
                              _vm._v("\n          arrow_drop_down\n        "),
                            ]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                1883362113
              ),
              model: {
                value: _vm.menu,
                callback: function ($$v) {
                  _vm.menu = $$v
                },
                expression: "menu",
              },
            },
            [
              _vm._v(" "),
              _vm.menu
                ? _c("v-list", { attrs: { dense: "" } }, [_vm._t("actions")], 2)
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }